export enum WebPushLinkType {
    LandingPage = 0,
    Listing = 1,
    HomeList = 2,
    BlogPost = 3,
    External = 4,
}
